if (!customElements.get("cart-upsell-slider")) {
  class CartUpsellSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      const slideContainer = this.querySelector(".swiper-container");
      const prevButton = this.querySelector(".swiper-button-prev");
      const nextButton = this.querySelector(".swiper-button-next");
      const pagination = this.querySelector(".swiper-pagination");

      if (!slideContainer) return;

      this.swiperInstance = new wcmmgLibs.Swiper(slideContainer, {
        slidesPerView: 1,
        spaceBetween: 16,
        loop: true,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
          },
          1024: {
            slidesPerView: 1,
          },
        },
      });
    }

    reinit() {
      if (this.swiperInstance) this.swiperInstance.destroy(true, true);
      this.initSlider();
    }
  }

  customElements.define("cart-upsell-slider", CartUpsellSlider);
}
